// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfigLink_formWrapper__Q9Q96 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 200px;
  font: var(--font-30);
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB {
  width: 650px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label p {
  margin: 0;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label span {
  color: #FF735C;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_inputDisabled__jmxIQ {
  cursor: not-allowed;
  opacity: 0.5;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_dropdown__k07Nr {
  display: none;
  position: absolute;
  width: 460px;
  background-color: #fff;
  top: 43px;
  right: 0;
  color: #000;
  z-index: 3;
  max-height: 400px;
  border-radius: 15px;
  overflow: scroll;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_dropdown__k07Nr .ConfigLink_listItem__vE1ek {
  padding: 5px 20px;
  cursor: pointer;
  border-bottom: 1px solid rgba(128, 128, 128, 0.5);
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_dropdown__k07Nr .ConfigLink_listItem__vE1ek:hover {
  background-color: rgba(128, 128, 128, 0.5);
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_dropdown__k07Nr .ConfigLink_listItem__vE1ek span {
  color: #000;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_dropdown__k07Nr .ConfigLink_listItem__vE1ek span:last-child {
  color: grey;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB label .ConfigLink_visibleList__-bk\\+Q {
  display: block;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB input, .ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB button {
  font: var(--font-30);
  border-radius: 15px;
  box-sizing: border-box;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB input {
  width: 460px;
  padding: 0 20px;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB button {
  margin-top: 25px;
  padding: 12px;
  border: 2px solid #fff;
  color: #fff;
  background-color: #000;
  cursor: pointer;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB .ConfigLink_btnDisabled__pzrex {
  cursor: not-allowed;
  opacity: 0.5;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB .ConfigLink_linkResult__BzCyI {
  width: 650px;
  word-break: break-all;
  white-space: normal;
  margin-top: 30px;
}
.ConfigLink_formWrapper__Q9Q96 .ConfigLink_form__StSpB .ConfigLink_linkResult__BzCyI a {
  color: #fff;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ConfigLink/ConfigLink.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AACF;AAAE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAEJ;AADI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAGN;AAFM;EACE,SAAA;AAIR;AAFM;EACE,cAAA;AAIR;AADM;EACE,mBAAA;EACA,YAAA;AAGR;AAAM;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAER;AADQ;EACE,iBAAA;EACA,eAAA;EACA,iDAAA;AAGV;AAFU;EACE,0CAAA;AAIZ;AAFU;EACE,WAAA;AAIZ;AAFU;EACE,WAAA;AAIZ;AAAM;EACE,cAAA;AAER;AACI;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;AACN;AACI;EACE,YAAA;EACA,eAAA;AACN;AACI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;AACN;AACI;EACE,mBAAA;EACA,YAAA;AACN;AACI;EACE,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AACN;AACM;EACE,WAAA;EACA,eAAA;AACR","sourcesContent":[".formWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 200px;\n  font: var(--font-30);\n  .form {\n    width: 650px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    label {\n      margin-top: 20px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      position: relative;\n      p {\n        margin: 0;\n      }\n      span {\n        color: #FF735C;\n      }\n\n      .inputDisabled {\n        cursor: not-allowed;\n        opacity: 0.5;\n      }\n\n      .dropdown {\n        display: none;\n        position: absolute;\n        width: 460px;\n        background-color: #fff;\n        top: 43px;\n        right: 0;\n        color: #000;\n        z-index: 3;\n        max-height: 400px;\n        border-radius: 15px;\n        overflow: scroll;\n        .listItem {\n          padding: 5px 20px;\n          cursor: pointer;\n          border-bottom: 1px solid rgba(128, 128, 128, 0.5);\n          &:hover {\n            background-color: rgba(128, 128, 128, 0.5);\n          }\n          span {\n            color: #000;\n          }\n          span:last-child {\n            color: grey;\n          }\n        }\n      }\n      .visibleList {\n        display: block;\n      }\n    }\n    input, button {\n      font: var(--font-30);\n      border-radius: 15px;\n      box-sizing: border-box;\n    }\n    input {\n      width: 460px;\n      padding: 0 20px;\n    }\n    button {\n      margin-top: 25px;\n      padding: 12px;\n      border: 2px solid #fff;\n      color: #fff;\n      background-color: #000;\n      cursor: pointer;\n    }\n    .btnDisabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n    .linkResult {\n      width: 650px;\n      word-break: break-all;\n      white-space: normal;\n      margin-top: 30px;\n\n      a {\n        color: #fff;\n        font-size: 25px;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formWrapper": `ConfigLink_formWrapper__Q9Q96`,
	"form": `ConfigLink_form__StSpB`,
	"inputDisabled": `ConfigLink_inputDisabled__jmxIQ`,
	"dropdown": `ConfigLink_dropdown__k07Nr`,
	"listItem": `ConfigLink_listItem__vE1ek`,
	"visibleList": `ConfigLink_visibleList__-bk+Q`,
	"btnDisabled": `ConfigLink_btnDisabled__pzrex`,
	"linkResult": `ConfigLink_linkResult__BzCyI`
};
export default ___CSS_LOADER_EXPORT___;
